import { render, staticRenderFns } from "./hotProductConfig2.vue?vue&type=template&id=a7bdf9ba&scoped=true"
import script from "./hotProductConfig2.vue?vue&type=script&lang=js"
export * from "./hotProductConfig2.vue?vue&type=script&lang=js"
import style0 from "./hotProductConfig2.vue?vue&type=style&index=0&id=a7bdf9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bdf9ba",
  null
  
)

export default component.exports